import Button from 'lib/components/button/Button';
import ProtectedComponent from 'lib/components/protected-component/ProtectedComponent';
import SearchInput from 'lib/components/search-input/SearchInput';
import { VIEW_SETTINGS_ROLES } from 'modules/settings/settingsPermissions';
import useSettingsAssetTypesList from '../../useSettingsAssetTypesList';
import SettingsAssetTypesInputModal from '../settings-asset-types-input-modal/SettingsAssetTypesInputModal';
import SettingsAssetTypesTable from '../settings-asset-types-table/SettingsAssetTypesTable';
import './SettingsAssetTypesListPage.scss';

export default function SettingsAssetTypesListPage(props) {
  const list = useSettingsAssetTypesList(props);

  return (
    <div className='settings-asset-types-list-page'>
      <div className='settings-header'>
        <h4>Asset types</h4>
      </div>
      <p className='form-info'>
        The list of types that can be selected for each asset displayed here.
      </p>
      <div className='row difect-filter-container'>
        <div className='search-container'>
          <SearchInput
            value={list.state.search}
            onChange={list.setSearch}
            data-testid='SettingsAssetTypesListPage.search'
          />
        </div>
        <ProtectedComponent allowed={VIEW_SETTINGS_ROLES}>
          <Button
            data-testid='SettingsAssetTypesListPage.addNewDefect'
            className='medium-button'
            onClick={list.userOpensInputModal}
          >
            Add asset type
          </Button>
        </ProtectedComponent>
      </div>
      <div className='settings-asset-types-table'>
        <SettingsAssetTypesTable
          editField={list.state.editField}
          data={list.state.data}
          setPageSize={list.setPageSize}
          pageSize={list.state.pageSize}
          sortBy={list.state.sortBy}
          sortOrder={list.state.sortOrder}
          setSortBy={list.sortBy}
          setPage={list.setPage}
          page={list.state.page}
          count={list.state.count}
          setEdit={list.userSelectsEditAssetType}
          clearEdit={list.userClearsEditAssetType}
          onChange={list.userTypesAssetTypeName}
          editAssetType={list.editSubmitsEditAssetType}
        />
      </div>
      <SettingsAssetTypesInputModal
        addType={list.state.addAssetType}
        isOpen={list.state.addAssetType.isModalOpen}
        onChange={list.userTypesNewAssetTypeLabel}
        onRequestClose={list.userCancelsInputModal}
        onSubmit={list.userSubmitsNewAssetType}
      />
    </div>
  );
}
